import {lazy} from 'react'
import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import {AppLayout} from '../../components/utils/AppLayout'
import {PageSuspenseFallback} from '../../components/utils/PageSuspenseFallback'
import {AuthProtectedLayout} from '../auth/components/AuthProtectedLayout'

const DashboardPage = lazy(() => import('./pages/DashboardPage'))

export const COMMON_ROUTES: RouteObject[] = [
  {
    path: '/dashboard',
    element: (
      <>
        <AppHelmet title='Dashboard' />
        <AuthProtectedLayout>
          <AppLayout>
            <PageSuspenseFallback>
              <DashboardPage />
            </PageSuspenseFallback>
          </AppLayout>
        </AuthProtectedLayout>
      </>
    ),
  },
]
